module.exports = __webpack_public_path__ + "static/media/kr.7fb0181b.svg";